import { triggerCustomEvent } from "../EventTrigger";
import { getCursorPosition, getPopupPosition } from "./PopupHelper";

export default class PopupHint
{
    protected hint: HTMLElement;
    protected classes = {
        opened: 'popup-hint_opened',
    }

    public constructor(hintSelector: string)
    {
        this.hint = document.querySelector(hintSelector);

        if (this.hint === null) {
            return;
        }

        this.appendCloseHandler();
    }

    public init()
    {
        if (this.hint === null) {
            return;
        }

        this.appendCloseHandler();
    }

    public appendCloseHandler()
    {
        let close = this.hint.querySelector('.popup-hint__close');
        
        if (close !== null) {
            close.addEventListener('click', () => this.hide());
        }
    }

    public setHint(title: string, text: string)
    {
        if (this.hint === null) {
            return;
        }

        this.hint.querySelector('.popup-hint__title').innerHTML = title;
        this.hint.querySelector('.popup-hint__text').innerHTML = text;
    }

    public show(target: Element, container: Element)
    {
        let maxWidth = container.clientWidth > 290 ? 290 : container.clientWidth;

        this.hint.style.top = 'auto';
        this.hint.style.left = 'auto';
        this.hint.style.maxWidth = maxWidth + 'px';

        this.display();

        let position = getPopupPosition(this.hint, target, container);

        this.hint.style.top  = position.top + target.clientHeight + this.hint.clientHeight + 10 + 'px';
        this.hint.style.left = position.left + 'px';

        let cursor = this.hint.querySelector('.popup-hint__cursor') as HTMLElement;
        if (cursor) {
            let cursorPostion = getCursorPosition(cursor, this.hint, target);
            cursor.style.left = cursorPostion.left + 'px';
        }
    }

    public isOpened(): boolean
    {
        return this.hint.classList.contains(this.classes.opened);
    }

    public hide()
    {
        this.hint.classList.remove(this.classes.opened);

        triggerCustomEvent(this.hint, 'hint-closed');
    }

    public getNode(): HTMLElement
    {
        return this.hint;
    }

    protected display()
    {
        this.hint.classList.add(this.classes.opened);
    }
}
